// @flow
import 'react-resizable/css/styles.css'

import usePermissions from 'hooks/usePermissions'
import { FormBuilderContextProvider } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import withStripe from 'utils/withStripe'

import PreviewForm from '../../PreviewForm'
import FormBuilderLayout from './FormBuilderLayout'

type Props = {
  children: React.Node,
}

export function FormBuilderWrapper({ children }: Props): React.Node {
  const history = useHistory()
  const match = useRouteMatch()
  const editFormId = match?.params?.resourceId

  const { location } = history
  const { state } = location
  const blockLoading = state?.blockLoading ?? false

  const { canEditPacketForm } = usePermissions()

  const editMode = editFormId !== undefined

  if (!canEditPacketForm && !editMode) {
    history.push('/forms')
  }

  if (!canEditPacketForm) {
    return <PreviewForm />
  }

  return (
    <FormBuilderContextProvider>
      <FormBuilderLayout
        blockLoading={blockLoading}
        editFormId={editFormId}
        editMode={editMode}
      >
        {children}
      </FormBuilderLayout>
    </FormBuilderContextProvider>
  )
}

const EnhancedFormBuilderPage: React.ComponentType<{}> =
  withStripe(FormBuilderWrapper)

export default EnhancedFormBuilderPage
